<template>
  <div class="services-page">
    <Breadcrumbs :links="breadCrumbsLinks"/>
    <div class="">
      <div v-if="pending"
           class="container">
        <div class="container-inner">
          <BasePreloader/>
        </div>
      </div>

      <div v-else-if="error"
           class="container">
        <ErrorView :code="error.code"
                   :title="error.message"
                   class="container-inner"/>
      </div>

      <div v-else class="container-inner">

      </div>

      <div v-if="pageGroupSlug === PAGE_INSURANCE"
           class="container">
        <div class="container-inner">
          <h1 class="services-page__title">
            {{ $tServices('Insurance title') }}
          </h1>
          <div class="services-page__iframe-wrap  _full">
            <IframeResize :src="insuranceWidgetLink"
                          class="services-page__iframe"/>
          </div>
        </div>
      </div>

      <div v-if="pageGroupSlug === PAGE_TICKETS"
           class="container">
        <div class="container-inner">
          <h1 class="services-page__title">
            {{ $tServices('Tickets title') }}
          </h1>

          <InteractionWidget v-if="widgetId === 1"
                             class="services-page__iframe-wrap">
            <script type="text/x-epodroznik-module" data-module-name="SearchingResults"
                    id="SearchingResults"></script>
            <div ref="content"></div>
          </InteractionWidget>

          <InteractionWidget v-else-if="widgetId === 2"
                             class="services-page__iframe-wrap">
            <script type="text/x-epodroznik-module" data-module-name="PurchaseProcess"
                    id="PurchaseProcess"></script>
            <div ref="content"></div>
          </InteractionWidget>

          <InteractionWidget v-else-if="widgetId === 3"
                             class="services-page__iframe-wrap">
            <script type="text/x-epodroznik-module" data-module-name="TicketsPanel"
                    id="TicketsPanel"></script>
            <div ref="content"></div>
          </InteractionWidget>

          <InteractionWidget v-else-if="widgetId === 4"
                             class="services-page__iframe-wrap">
            <script type="text/x-epodroznik-module" data-module-name="UserDetails"
                    id="UserDetails"></script>
            <div ref="content"></div>
          </InteractionWidget>

          <InteractionWidget v-else
                             class="services-page__iframe-wrap">
            <script type="text/x-epodroznik-module"
                    data-module-name="ConnectionsSearcher"
                    id="ConnectionsSearcher"></script>
            <!--            <script type="text/x-epodroznik-module" data-module-name="UserMenu"-->
            <!--                    id="UserMenu"></script>-->
            <div ref="content"></div>
          </InteractionWidget>
        </div>
      </div>

      <template v-if="pageGroupSlug === PAGE_COMPANY_INFO && !noCompanyInfo">
        <CompanyDossierPage companySlugRouteKey="childId"
                            class="services-page__company-info"/>
      </template>


      <div v-if="$get(faq, 'length') || titleBody || textBody"
           class="container">
        <div class="services-page__info-section  container-inner">
          <template v-if="$get(faq, 'length')">
            <h2 class="services-page__sub-title">{{ $tServices('Often asked') }}</h2>
            <AccordionInfo :items="faq"
                           class="services-page__faq"/>
          </template>
          <h2 v-if="titleBody"
              class="services-page__sub-title">{{ titleBody }}</h2>
          <div v-if="textBody"
               class="services-page__info-text  text" v-html="textBody">

          </div>
        </div>
      </div>
      <HomePageReviews v-if="$get(reviews, 'data.length')" :reviews="reviews.data"/>
    </div>
  </div>
</template>

<script>
  import {http} from '@/axios'
  import globalMetaMixin from '@/mixins/globalMetaMixin'
  import Breadcrumbs from '@/components/Breadcrumbs';
  import ErrorView from '@/components/ErrorView'
  import AccordionInfo from '@/components/AccordionInfo'
  import InteractionWidget from '@/components/interactions/InteractionWidget'
  import CompanyDossierPage from '@/views/CompanyDossierPage'
  import HomePageReviews from '@/components/homePage/HomePageReviews'
  import IframeResize from '@/components/IframeResize'
  import {setMetaRobots} from '@/helpers/metaRobots'

  const PAGE_INSURANCE = 'insurance'
  const PAGE_TICKETS = 'tickets'
  const PAGE_COMPANY_INFO = 'company-info'

  export default {
    name: 'OneServicePage',
    mixins: [globalMetaMixin],
    components: {
      HomePageReviews,
      Breadcrumbs,
      ErrorView,
      AccordionInfo,
      InteractionWidget,
      CompanyDossierPage,
      IframeResize,
    },
    data() {
      return {
        pendingIframe: true,
        pending: false,
        error: null,

        faq: null,
        title: null,
        titleBody: null,
        textBody: null,

        PAGE_INSURANCE,
        PAGE_TICKETS,
        PAGE_COMPANY_INFO,

        reviews: null,
      }
    },
    computed: {
      noCompanyInfo() {
        return this.$route.params.id == PAGE_COMPANY_INFO
      },
      breadCrumbsLinks() {
        const links = [{
          href: '/services/',
          name: this.$tServices('Services'),
          route: {
            name: 'services'
          }
        }]

        if (this.title) {
          links.push({
            name: this.title
          })
        }

        return links
      },
      pageGroupSlug() {
        return this.$route.params.id
      },
      slug() {
        if (this.pageGroupSlug === PAGE_COMPANY_INFO) {
          return this.$route.params.id
        }

        return this.$route.params.childId || this.$route.params.id
      },
      currentLang() {
        const lang = this.$store.state.locales[this.$store.state.currentLocale]

        return lang.regional.substring(0, 2)
      },
      widgetId() {
        return Number(this.$route.params.widgetId) || null
      },
      insuranceWidgetLink() {
        const lang = this.currentLang
        const p = this.$route.query.p || ''
        const mode = location.hostname === 'jobian.com' ? 'prod' : 'dev'
        const userToken = this.$store.state.user.token || ''
        const userId = this.$get(this.$store.state.user, 'profile.id', '')
        const params = this.$route.query.params || ''

        const query = `lang=${lang}&p=${p}&params=${params}&mode=${mode}&token=${userToken}&interaction_id=${userId}`

        return `https://insurance.jobian.com/${params ? 'agents' : ''}${params && p ? '/' : ''}${p ? 'success' : ''}?${query}`
      }
    },
    methods: {

      load() {
        this.pending = true

        http.get(`/api/services/${this.slug}`).then(({data}) => {
          this.service = data.data.service

          this.faq = data.data.faq ? data.data.faq.map(item => {
            return {
              name: item.question,
              content: item.answer
            }
          }) : null

          this.textBody = data.data.body
          this.titleBody = data.data.body_title

          this.reviews = data.data.reviews

          this.setMetaTitleMixin(data.data.meta_title)
          this.setMetaDescriptionMixin(data.data.meta_description)
          this.setMetaKeywords(data.data.meta_keywords)

          this.setOpenGraph({
            title: data.data.meta_title,
            description: data.data.meta_description,
          })
        }).catch((error) => {
          this.error = {
            code: error.response.status,
            message: error.response.data && error.response.data.message || error.message
          }
        }).finally(() => {
          this.pending = false
        })
      },
      getClassByIndex(index) {
        let selector = ''

        if (this.services.length % 3) {
          if (!(this.services.length % 2) || index < this.services.length - 3) {
            selector += ' _wide'
          }
        }

        if (this.services.length % 2 && index === this.services.length - 1) {
          selector += ' _wide-sm'
        }

        // if (
        //     (this.services.length % 2 && index === this.services.length - 1)
        //     || index === this.services.length - 2
        // ) {
        //   selector += ' _last'
        // }

        return selector
      },
    },
    created() {
      if (this.noCompanyInfo) {
        setMetaRobots('noindex, follow')
        this.error = {
          code: 404,
          title: "Not Found"
        }
      } else {
        this.load()
      }
    },
    beforeDestroy() {
      this.deleteMetaKeywords()
    },
    watch: {
      slug() {
        this.load()
      }
    },
    mounted() {

    }
  }
</script>

<style lang="less">

</style>
